import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { gridPageRequest } from '../../../model/common/common.model';
import { Table } from 'primeng/table';
import _ from 'lodash';

@Component({
  selector: 'app-FRQProduct-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './FRQProduct-lookup.component.html',
  styleUrl: './FRQProduct-lookup.component.scss'
})
export class RFQProductLookupComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  constructor(public dialogService: DialogService, private config: DynamicDialogConfig, public ref: DynamicDialogRef,) { }

  loader: boolean = false;
  list: any[] = [];
  vendor: any;
  searchKey: string | undefined;
  vendorProductPrices: any;

  pageRequest: gridPageRequest = {
    pageIndex: 1,
    pageSize: 20,
    id: 0
  }

  ngOnInit(): void {
    this.vendor = this.config.data?.vendor;
    this.list = (this.config.data?.products || []).map((p: any) => ({
      ...p,
      qty: p.qty ?? '',
      requiredDate: p.requiredDate ?? '',
      quotedPrice: p.quotedPrice != null && p.quotedPrice !== '' ? Number(p.quotedPrice) : 0.00,
      freight: p.freight != null && p.freight !== '' ? Number(p.freight) : 0,
      leadTime: p.leadTime != null && p.leadTime !== '' ? Number(p.leadTime) : 0.00
    }));
  }

  save() {
    this.list = this.list.map(product => ({
      ...product,
      quotedPrice: product.quotedPrice != null && product.quotedPrice !== '' ? Number(product.quotedPrice) : 0.00,
      freight: product.freight != null && product.freight !== '' ? Number(product.freight) : 0,
      leadTime: product.leadTime != null && product.leadTime !== '' ? Number(product.leadTime) : 0.00,
      requiredDate: product.requiredDate ?? null
    }));
    this.ref.close(this.list);
  }

  search() { }

  refreshData() {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageSize = 20;
    this.list = (this.config.data?.products || []).map((p: any) => ({ ...p }));
  }

  load(event: any): void {
    if (this.searchKey && this.searchKey.trim() !== '') {
      return;
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    }
  }

}
